import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/hostAllBookings';

import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(actionTypes.load.toString(), load);
}
